export const SellerData = [
    {
        id: 1,
        name: "Pizza",
        price: 15.99,
        description: "Here you will be offered perfectly cooked tandoori pizza, chicken tikka and chicken sausages. Food delivery is a big benefit of Ovenstory Pizza. Many people point out that the staff is good at this place. Fine service is something visitors appreciate here.",
        image: "https://th.bing.com/th/id/R.8829f4e35694c245b9c1d7e84b5e27e1?rik=5%2fCD%2bB5XXckl%2fQ&riu=http%3a%2f%2fnogluten-noproblem.com%2fwp-content%2fuploads%2f2020%2f03%2fP1110869-1920x1920.jpg&ehk=k3tt368pxDBRtDDvwqnCG03IYn5JH4PN1nPj3jbHmJs%3d&risl=&pid=ImgRaw&r=0"
    },
    {
        id: 2,
        name: "Veg Burger",
        price: 10.99,
        description: "One of the finest burgers that you would have ever eaten in this world.",
        image: "https://th.bing.com/th/id/OIP.YnePzFyWLp4ni7av2rk4eQHaHa?pid=ImgDet&rs=1"
    }
]